<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/Save-Quotes"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li class="active" routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li routerLink="/dashboard/forms"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li routerLink="/dashboard/resources"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
    </div>
</div>
